import { Link } from "react-router-dom";
import Swal from "sweetalert2";
const ProductCard = ({
  itemId,
  image,
  category,
  title,
  rating,
  reviews,
  price,
  oldPrice,
  badge = "Sale",
  best,
  onAddToCart,
  addedToCart,
  onAddToWishlist,
  onRemoveFromWishlist,
  isWishlisted,
  discountPercent,
}) => {
  const handleAddClick = () => {
    Swal.fire({
      icon: "success",
      title: "Added to Cart",
      text: "Product has been added to your cart!",
      showConfirmButton: true,
      timer: 3000,
    });
  };

  return best == "false" ? (
    <div className="col fade-zoom">
      <div className="card card-product h-100">
        <div className="card-body">
          {/* Badge */}
          <div className="text-center position-relative">
            <div className="position-absolute top-0 start-0">
              <span className="badge bg-danger">{badge}</span>
            </div>

            {/* Product Image */}
            <Link to="#!">
              <img
                src={image}
                alt={title}
                className="mb-3 img-fluid"
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
            </Link>

            {/* Action Buttons */}
            <div className="card-product-action">
              <Link
                to={`/ShopProduct?itemId=${itemId}`}
                className="btn-action"
                // data-bs-toggle="modal"
                // data-bs-target="#quickViewModal"
              >
                <i className="bi bi-eye" title="Quick View" />
              </Link>

              <button
                type="button"
                className="btn-action"
                title="Wishlist"
                onClick={isWishlisted ? onRemoveFromWishlist : onAddToWishlist}
                // disabled={isWishlisted}
              >
                <i
                  className={`bi ${
                    isWishlisted ? "bi-heart-fill text-danger" : "bi-heart"
                  }`}
                />
              </button>
              {/* 
              <Link to="#!" className="btn-action" title="Compare">
                <i className="bi bi-arrow-left-right" />
              </Link> */}
            </div>
          </div>

          {/* Category */}
          {/* <div className="text-small mb-1">
            <Link
              to="#!"
              className="text-decoration-none text-muted"
            >
              <small>{category}</small>
            </Link>
          </div> */}

          {/* Product Title */}
          <h2
            className="fs-6"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              minHeight: "48px",
              lineHeight: "24px",
            }}
          >
            <Link to="#!" className="text-inherit text-decoration-none">
              {title}
            </Link>
          </h2>

          {/* Rating */}
          {/* <div>
            <small className="text-warning">
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-fill" />
              <i className="bi bi-star-half" />
            </small>

            <span className="text-muted small ms-1">
              {rating} ({reviews})
            </span>
          </div> */}

          {/* Price */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex flex-column">
              {discountPercent != 0 ? (
                <>
                  <span className="text-dark fw-bold">₹{price}</span>
                  <span className="text-decoration-line-through text-muted small">
                    ₹{oldPrice}
                  </span>
                </>
              ) : (
                <span className="text-dark fw-bold">₹{price}</span>
              )}
            </div>

            {/* Add Button */}
            <div>
              <button
                className="btn btn-primary btn-sm"
                onClick={onAddToCart}
                disabled={addedToCart}
              >
                {addedToCart ? (
                  <>
                    <i className="bi bi-check-lg me-1"></i>
                    Added to Cart
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-plus"
                    >
                      <line x1={12} y1={5} x2={12} y2={19} />
                      <line x1={5} y1={12} x2={19} y2={12} />
                    </svg>{" "}
                    Add
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="images swiper-slide px-4 ">
      <div className="col ">
        <div className="card card-product" style={{ height: "400px" }}>
          <div className="card-body">
            <div className="text-center  position-relative ">
              {" "}
              <Link to="#!">
                <img
                  src={image}
                  alt={title}
                  className="mb-3 img-fluid"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              </Link>
              {/* Action Buttons */}
              <div className="card-product-action">
                <Link
                  to={`/ShopProduct?itemId=${itemId}`}
                  className="btn-action"
                  // data-bs-toggle="modal"
                  // data-bs-target="#quickViewModal"
                >
                  <i className="bi bi-eye" title="Quick View" />
                </Link>

                <button
                  type="button"
                  className="btn-action"
                  title="Wishlist"
                  onClick={
                    isWishlisted ? onRemoveFromWishlist : onAddToWishlist
                  }
                  // disabled={isWishlisted}
                >
                  <i
                    className={`bi ${
                      isWishlisted ? "bi-heart-fill text-danger" : "bi-heart"
                    }`}
                  />
                </button>
                {/* 
              <Link to="#!" className="btn-action" title="Compare">
                <i className="bi bi-arrow-left-right" />
              </Link> */}
              </div>
            </div>
            <div className="text-small mb-1">
              <Link
                to="#!"
                className="text-decoration-none text-muted"
                style={{
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <small>{category}</small>
              </Link>
            </div>
            <h2
              className="fs-6"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                minHeight: "48px",
                lineHeight: "24px",
              }}
            >
              <Link to="#!" className="text-inherit text-decoration-none">
                {title}
              </Link>
            </h2>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                <span className="text-dark">₹{price}</span>{" "}
                <span className="text-decoration-line-through text-muted">
                  ₹{oldPrice}
                </span>
              </div>
              {/* <div>
                <small className="text-warning">
                  {" "}
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-half" />
                </small>
                <span>
                  <small>{rating}</small>
                </span>
              </div> */}
            </div>
            <div className="d-grid mt-2">
              <button
                to="#!"
                className="btn btn-primary"
                onClick={onAddToCart}
                disabled={addedToCart}
              >
                {addedToCart ? (
                  <>
                    <i className="bi bi-check-lg me-1"></i>
                    Added to Cart
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-plus"
                    >
                      <line x1={12} y1={5} x2={12} y2={19} />
                      <line x1={5} y1={12} x2={19} y2={12} />
                    </svg>{" "}
                    Add to cart{" "}
                  </>
                )}
              </button>
            </div>
            <div className="d-flex justify-content-start text-center mt-3">
              <div
                className="deals-countdown w-100"
                data-countdown="2022/11/11 00:00:00"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
